import { Link } from "react-router-dom";
import "./LandingPage.css";
import { useState, useEffect } from "react";
import { saveLead } from "../../services/leadService";
import { Helmet } from "react-helmet";
import { FaWhatsapp } from "react-icons/fa";

// import logoo from "../../assets/images/gymfithorlogo2-removebg-preview.png";
// import companylogo22 from "../../assets/images/companylogo22.png";
import logoo from "../../assets/images/gymfitorangelogo22.png";
import reportsandana from "../../assets/images/reportsandana.png";
import membersImg from "../../assets/images/adim3.png";
import paymentsImg from "../../assets/images/adim4.png";
import gymDashboardImg from "../../assets/images/admin2.png";
import idcard from "../../assets/images/idcard.png";
import trainer from "../../assets/images/trainer.png";

import CountUp from "react-countup";
import { FaBars, FaTimes } from "react-icons/fa";
import { getPlans } from "../../services/subscriptionService";

import {
  FaUsers,
  FaCalendarCheck,
  FaMoneyBillWave,
  FaChartLine,
  FaDumbbell,
  FaCloud,
} from "react-icons/fa";
import gymimage1 from "../../assets/images/gymimage1.png";
import gymimage2 from "../../assets/images/gymimage2.png";
import gymimage3 from "../../assets/images/gymimage3.png";
import landingpageimage from "../../assets/images/landingpageimage.png";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail, MdLanguage } from "react-icons/md";

function PricingCard({ title, plans, selected, setSelected }) {
  if (!selected) return null;

  return (
    <div className="pricing-card">
      <h3>{title}</h3>

      <div className="radio-group">
        {plans.map((plan) => (
          <label
            key={plan.id}
            className={`duration-option ${
              selected.id === plan.id ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name={title}
              checked={selected.id === plan.id}
              onChange={() => setSelected(plan)}
            />

            <div className="duration-info">
              <span>{plan.duration}</span>

              <span>₹{Number(plan.price).toLocaleString()}</span>
            </div>
          </label>
        ))}
      </div>

      <div className="price">₹{Number(selected.price).toLocaleString()}</div>

      <ul>
        <li>✓ {selected.features.memberLimit} Members</li>
        <li>✓ {selected.features.trainerLimit} Trainers</li>
        <li>✓ {selected.features.storageLimit} MB Storage</li>
        {selected.features.attendance && <li>✓ Attendance</li>}
        {selected.features.payments && <li>✓ Payments</li>}
        {selected.features.reports && <li>✓ Reports</li>}
        {selected.features.membershipPlans && <li>✓ Membership Plans</li>}
        {selected.features.trainers && <li>✓ Trainer Management</li>}
        {selected.features.qrScanner && <li>✓ QR Scanner</li>}
        {selected.features.memberPortal && <li>✓ Member Portal</li>}
        {selected.features.dietPlan && <li>✓ Diet Plan</li>}
        {selected.features.aiWorkout && <li>✓ AI Workout</li>}
        {selected.features.customerSupport && <li>✓ Priority Support</li>}
      </ul>

      <Link to="/register" className="pricing-btn">
        Start Now
      </Link>
    </div>
  );
}

export default function LandingPage() {
  const [lead, setLead] = useState({
    name: "",
    gymName: "",
    phone: "",
    email: "",
    message: "",
  });
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [plans, setPlans] = useState([]);

  const [selectedPlans, setSelectedPlans] = useState({
    Basic: null,
    Standard: null,
    Premium: null,
  });

  const groupedPlans = {
    Basic: plans.filter((p) => p.planName === "Basic"),
    Standard: plans.filter((p) => p.planName === "Standard"),
    Premium: plans.filter((p) => p.planName === "Premium"),
  };

  const toggleFAQ = (index) => {
    if (activeFAQ === index) {
      setActiveFAQ(null);
    } else {
      setActiveFAQ(index);
    }
  };

  useEffect(() => {
    const loadPlans = async () => {
      const planData = await getPlans();

      setPlans(planData);

      setSelectedPlans({
        Basic:
          planData.find(
            (p) => p.planName === "Basic" && p.duration === "1 Month",
          ) || null,

        Standard:
          planData.find(
            (p) => p.planName === "Standard" && p.duration === "1 Month",
          ) || null,

        Premium:
          planData.find(
            (p) => p.planName === "Premium" && p.duration === "1 Month",
          ) || null,
      });
    };

    loadPlans();
  }, []);

  // const loadPlans = async () => {
  //   try {
  //     const data = await getPlans();

  //     // Optional: sort by duration or price
  //     data.sort((a, b) => Number(a.price) - Number(b.price));

  //     setPlans(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleChange = (e) => {
    setLead({
      ...lead,
      [e.target.name]: e.target.value,
    });
  };

  const handleLeadSubmit = async (e) => {
    e.preventDefault();

    // Required field validation
    if (!lead.name.trim()) {
      alert("Please enter your name");
      return;
    }

    if (!lead.gymName.trim()) {
      alert("Please enter your gym name");
      return;
    }

    if (!lead.phone.trim()) {
      alert("Please enter your phone number");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(lead.phone)) {
      alert("Phone number must be exactly 10 digits.");
      return;
    }

    if (!lead.email.trim()) {
      alert("Please enter your email");
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(lead.email)) {
      alert("Please enter a valid email address");
      return;
    }

    if (!lead.message.trim()) {
      alert("Please enter your message");
      return;
    }

    try {
      await saveLead(lead);

      alert("Demo Request Submitted");

      setLead({
        name: "",
        gymName: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      alert("Failed To Submit");
    }
  };
  const message = encodeURIComponent(
    `Hi NN AI Solutions,

I visited your Gym Management Software website and I'm interested in your Service platform.

Could you please provide details about:
• Pricing plans
• Features
• Free demo
• Support

Thank you!`,
  );

  const faqData = [
    {
      question: "Can I manage unlimited members?",
      answer: "No. Plans support Limited members.",
    },
    {
      question: "Is my data secure?",
      answer: "Yes. Data is securely stored using Firebase Cloud.",
    },
    {
      question: "Can I track attendance?",
      answer: "Yes. QR code and manual attendance are supported.",
    },
    {
      question: "Can I manage trainers?",
      answer: "Yes. Assign trainers and manage members easily.",
    },
    {
      question: "Can I renew memberships?",
      answer: "Yes. Membership renewals are automated.",
    },
    {
      question: "Do you provide support?",
      answer: "Yes. WhatsApp and email support are available.",
    },
  ];
  return (
    <div className="landing-page">
      <Helmet>
        <title>NN FIT</title>

        <meta
          name="description"
          content="Manage Members, Attendance, Trainers, Payments and Reports with Gym SaaS."
        />

        <meta
          name="keywords"
          content="
      gym software,
      gym management software,
      fitness software,
      gym attendance system,
      gym billing software,
      gym CRM
    "
        />

        <meta property="og:title" content="Gym SaaS" />

        <meta
          property="og:description"
          content="Professional Gym Management Platform"
        />
      </Helmet>
      <>
        <nav className="navbar">
          <div className="logo">
            <img src={logoo} alt="logo" className="logocss" />
            <p className="logopara">Smart Gym & Fitness Management Software</p>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            {/* <a href="#home">Home</a> */}
            <a href="#features">Features</a>
            <a href="#pricing">Pricing</a>
            <a href="#testimonials">Testimonials</a>

            <Link to="/login" className="login-nav-btn">
              Login
            </Link>
          </div>
        </nav>
        {/* Hero */}
        <section
          className="hero"
          style={{
            backgroundImage: `url(${landingpageimage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="hero-overlay"></div>

          <div className="hero-content">
            <h1>Manage Your Gym Efficiently</h1>

            <p>
              Track Members, Attendance, Trainers, Payments and Revenue in one
              platform.
            </p>
            <div className="hero-badge"> FREE 1-DAY TRIAL</div>

            <p>
              Experience our complete Gym Management Software with a FREE 1-Day
              Trial. Starts after admin approval. No hidden charges.
            </p>

            <div className="hero-buttons">
              <Link to="/register" className="primary-btn">
                Start Free Trial
              </Link>

              <a href="#pricing" className="secondary-btn">
                View Pricing
              </a>
            </div>
          </div>
        </section>
        <section className="trial-section">
          <div className="trial-content">
            <span className="trial-tag"> FREE OFFER</span>

            <h2>Start Your FREE 1-Day Trial Today</h2>

            <p>
              Explore every premium feature before purchasing. Your trial begins
              only after your gym is approved by our team.
            </p>

            <div className="trial-features">
              <div>No Credit Card Required</div>
              <div> Full Premium Features</div>
              <div>Instant Dashboard Access</div>
              <div>Easy Upgrade Anytime</div>
            </div>

            <Link to="/register" className="trial-btn">
              Claim Your Free Trial
            </Link>
          </div>
        </section>
        {/* Trusted */}
        <section className="trusted-section">
          <h2>Trusted By Leading Fitness Centers</h2>

          <div className="trusted-grid">
            <div>ULTRAFIT</div>
            <div>POWERHOUSE</div>
            <div>ELITE GYM</div>
            <div>CORE FITNESS</div>
            <div>FITZONE</div>
          </div>
        </section>
        {/* static */}
        {/* <section className="stats-section">
          <div className="stats-card">
            <h2>
              <CountUp end={500} duration={3} />+
            </h2>
            <p>Gyms Using Platform</p>
          </div>

          <div className="stats-card">
            <h2>
              <CountUp end={50000} duration={3} separator="," />+
            </h2>
            <p>Active Members</p>
          </div>

          <div className="stats-card">
            <h2>
              <CountUp end={1000000} duration={4} separator="," />+
            </h2>
            <p>Attendance Records</p>
          </div>

          <div className="stats-card">
            <h2>
              ₹<CountUp end={5} duration={3} />
              Cr+
            </h2>
            <p>Revenue Processed</p>
          </div>
        </section> */}
        {/* Why Choose Gym SaaS */}
        <section className="why-section">
          <div className="section-title">
            <h2>Why Choose Gym Service?</h2>

            <p>
              Everything your fitness business needs to manage members,
              trainers, attendance and payments efficiently.
            </p>
          </div>

          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon">
                <FaUsers />
              </div>
              <h3>Member Management</h3>
              <p>Manage unlimited gym members with complete profile details.</p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <FaCalendarCheck />
              </div>
              <h3>Attendance Tracking</h3>
              <p>Monitor daily attendance using QR code scanning.</p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <FaMoneyBillWave />
              </div>
              <h3>Payment Tracking</h3>
              <p>Track payments, dues, renewals and revenue instantly.</p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <FaChartLine />
              </div>
              <h3>Analytics Dashboard</h3>
              <p>Powerful charts and reports to grow your gym business.</p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <FaDumbbell />
              </div>
              <h3>Trainer Management</h3>
              <p>Assign trainers and monitor trainer performance.</p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <FaCloud />
              </div>
              <h3>Cloud Based</h3>
              <p>Access your gym from anywhere using any device.</p>
            </div>
          </div>
        </section>
        {/* Features */}
        <section id="features" className="features-section">
          <h2>Everything You Need</h2>

          <div className="feature-grid">
            <div className="feature-card">
              <h3>Members</h3>
              <p>Manage unlimited gym members.</p>
            </div>

            <div className="feature-card">
              <h3>Attendance</h3>
              <p>Track attendance with QR system.</p>
            </div>

            <div className="feature-card">
              <h3>Payments</h3>
              <p>Manage all payment records.</p>
            </div>

            <div className="feature-card">
              <h3>Reports</h3>
              <p>Powerful analytics dashboard.</p>
            </div>

            <div className="feature-card">
              <h3>Trainers</h3>
              <p>Assign trainers to members.</p>
            </div>

            <div className="feature-card">
              <h3>Renewals</h3>
              <p>Automatic expiry tracking.</p>
            </div>
          </div>
        </section>
        {/* Pricing */}
        <section id="pricing" className="pricing-section">
          <h2>Choose Your Plan</h2>

          <div className="pricing-grid">
            <PricingCard
              title="Basic"
              plans={groupedPlans.Basic}
              selected={selectedPlans.Basic}
              setSelected={(plan) =>
                setSelectedPlans((prev) => ({
                  ...prev,
                  Basic: plan,
                }))
              }
            />

            <PricingCard
              title="Standard"
              plans={groupedPlans.Standard}
              selected={selectedPlans.Standard}
              setSelected={(plan) =>
                setSelectedPlans((prev) => ({
                  ...prev,
                  Standard: plan,
                }))
              }
            />

            <PricingCard
              title="Premium"
              plans={groupedPlans.Premium}
              selected={selectedPlans.Premium}
              setSelected={(plan) =>
                setSelectedPlans((prev) => ({
                  ...prev,
                  Premium: plan,
                }))
              }
            />
          </div>
        </section>
        {/* Testimonials */}
        <section id="testimonials" className="testimonial-section">
          <h2>What Gym Owners Say</h2>

          <div className="testimonial-grid">
            <div className="testimonial-card">
              <p>Gym Service reduced our workload by 40%.</p>

              <h4>Surya</h4>
            </div>

            <div className="testimonial-card">
              <p>Revenue tracking is amazing.</p>

              <h4>Vijay</h4>
            </div>

            <div className="testimonial-card">
              <p>Easy to use and highly professional.</p>

              <h4>Sabbar</h4>
            </div>
          </div>
        </section>
        {/* blog scetion */}
        <section className="blog-section">
          <div className="section-title">
            <h2>Latest Fitness Business Insights</h2>

            <p>
              Learn how to grow your gym business using technology, automation
              and modern fitness management tools.
            </p>
          </div>

          <div className="blog-grid">
            <div className="blog-card">
              <img src={gymimage1} alt="image one" />

              <div className="blog-content">
                <h3>5 Ways To Increase Gym Membership Renewals</h3>

                <p>
                  Discover strategies that improve retention and membership
                  renewals.
                </p>
              </div>
            </div>

            <div className="blog-card">
              <img src={gymimage2} alt="gymimage2" />

              <div className="blog-content">
                <h3>Why Every Gym Needs Management Software</h3>

                <p>Save time, reduce paperwork and automate operations.</p>
              </div>
            </div>

            <div className="blog-card">
              <img src={gymimage3} alt="gymimage3" />

              <div className="blog-content">
                <h3>Best Marketing Strategies For Gyms</h3>

                <p>Attract more customers through digital marketing.</p>
              </div>
            </div>
          </div>
        </section>
        {/* ================= Gallery ================= */}
        <section className="gallery-section">
          <div className="section-title">
            <h2>Gym Software Screenshots</h2>

            <p>
              Explore our modern dashboard built for gym owners to manage
              members, payments, trainers, attendance and business analytics.
            </p>
          </div>

          <div className="gallery-grid">
            <div className="gallery-card">
              <img src={gymDashboardImg} alt="Gym Dashboard" />

              <div className="gallery-overlay">
                <h3>Gym Dashboard</h3>
                <p>Complete business overview.</p>
              </div>
            </div>

            <div className="gallery-card">
              <img src={membersImg} alt="Members Management" />

              <div className="gallery-overlay">
                <h3>Members Management</h3>
                <p>Manage members.</p>
              </div>
            </div>

            <div className="gallery-card">
              <img src={paymentsImg} alt="Payments" />

              <div className="gallery-overlay">
                <h3>Payments</h3>
                <p>Track revenue & payments.</p>
              </div>
            </div>

            <div className="gallery-card">
              <img src={reportsandana} alt="Analytics Dashboard" />

              <div className="gallery-overlay">
                <h3>Analytics</h3>
                <p>Revenue & reports.</p>
              </div>
            </div>

            <div className="gallery-card">
              <img src={idcard} alt="Super Admin" />

              <div className="gallery-overlay">
                <h3>Customer ID</h3>
                <p>Verify using ID card.</p>
              </div>
            </div>

            <div className="gallery-card">
              <img src={trainer} alt="Revenue Analytics" />

              <div className="gallery-overlay">
                <h3>Trainer Analytics</h3>
                <p>Trainer Management insights.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            <p>Everything gym owners ask before purchasing.</p>
          </div>

          <div className="faq-container">
            {faqData.map((faq, index) => (
              <div className="faq-item" key={index}>
                <div className="faq-header" onClick={() => toggleFAQ(index)}>
                  <h3>{faq.question}</h3>

                  <button className="faq-btn">
                    {activeFAQ === index ? "−" : "+"}
                  </button>
                </div>

                {activeFAQ === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
        {/* {contact section} */}
        <section className="contact-section">
          <div className="contact-left">
            <h2>Book Free Demo</h2>

            <p>
              Interested in Gym Service? Fill the form and our team will contact
              you.
            </p>

            <div className="footer-contact">
              <p>
                <FaPhoneAlt className="footer-icon" />
                <span>8688663447</span>
              </p>

              <p>
                <FaEnvelope className="footer-icon" />
                <span>info@nnfit.in</span>
              </p>

              <p>
                <FaMapMarkerAlt className="footer-icon" />
                <span>
                  IT Towers, 1st Floor, Near New Collector Office, Nizamabad,
                  Telangana - 503001
                </span>
              </p>
            </div>
          </div>

          <div className="contact-right">
            <form onSubmit={handleLeadSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Owner Name"
                value={lead.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="gymName"
                placeholder="Gym Name"
                value={lead.gymName}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={lead.phone}
                onChange={handleChange}
                required
                maxLength={10}
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={lead.email}
                onChange={handleChange}
                required
              />

              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                value={lead.message}
                onChange={handleChange}
              />

              <button type="submit">Request Demo</button>
            </form>
          </div>
        </section>

        <a
          href={`https://wa.me/918688663447?text=${message}`}
          target="_blank"
          rel="noreferrer"
          className="whatsapp-float"
        >
          <FaWhatsapp />
        </a>

        <section className="map-section">
          <div className="section-title">
            <h2>Visit Our Office</h2>
          </div>

          <div className="office-grid">
            <div className="office-details">
              <h3>NN AI Solutions</h3>

              <p>IT Towers, 1st Floor</p>

              <p>Near New Collector Office</p>

              <p>Nizamabad, Telangana 503001</p>

              <p>
                <MdPhone className="footer-icon" />
                +91 8688663447
              </p>

              <p>
                <MdEmail className="footer-icon" />
                info@nnfit.in
              </p>

              <a
                href="https://www.google.com/maps?q=IT+Hub+Nizamabad"
                target="_blank"
                rel="noreferrer"
                className="direction-btn"
              >
                Get Directions
              </a>
            </div>

            <div className="map-container">
              <iframe
                title="Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.263489063145!2d78.0975252727156!3d18.6970180637655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcddb88ac169bdf%3A0x9727e25e054cf513!2sIT%20HUB%20Nizamabad!5e0!3m2!1sen!2sin!4v1782550139866!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />

              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.263489063145!2d78.0975252727156!3d18.6970180637655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcddb88ac169bdf%3A0x9727e25e054cf513!2sIT%20HUB%20Nizamabad!5e0!3m2!1sen!2sin!4v1782550139866!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe> */}
            </div>
          </div>
        </section>
        <footer className="footer">
          <div className="footer-container">
            {/* Company Info */}
            <div className="footer-section">
              <img src={logoo} alt="NN FIT Logo" className="logocsss" />
              <h3>NN FIT</h3>
              <p>
                Gym Management Software designed to streamline memberships,
                billing, attendance, trainer management, and business growth.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <a href="#features">Features</a>
                </li>
                <li>
                  <a href="#pricing">Pricing</a>
                </li>
                <li>
                  <a href="#testimonials">Testimonials</a>
                </li>
                <li>
                  <a href="/login">Login</a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h4>Our Services</h4>
              <ul>
                <li>Gym Management Software</li>
                <li>Mobile App Solutions</li>
                <li>Website Development</li>
                <li>Digital Marketing</li>
                <li>AI Automation</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4>Contact Us</h4>

              <p>
                <MdLocationOn className="footer-icon" />
                IT Towers, 1st Floor, Near New Collector Office, Nizamabad,
                Telangana - 503001
              </p>

              <p>
                <MdPhone className="footer-icon" />
                +91 8688663447
              </p>

              <p>
                <MdEmail className="footer-icon" />
                info@nnfit.in
              </p>

              <p>
                <MdLanguage className="footer-icon" />
                www.nnaisolution.com
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© 2026 NN FIT. All Rights Reserved.</p>

            <p>Designed & Developed by NN AI Solutions</p>
          </div>
        </footer>
      </>
    </div>
  );
}
